module.exports = __webpack_public_path__ + "static/media/feedback.23230372.png";